/**
 * Constantes propias del ER v2.
 *
 * El v2 EXTIENDE las del v1 en vez de modificarlas: `src/pages/ER/constants.js` lo consumen
 * el v1 (12+ call sites en su index.js y su propio CostosFijosTable), y el v1 está CONGELADO.
 * Agregarle un concepto ahí le sumaría una fila al v1 — cambio de render en la vista vieja,
 * exactamente lo que la hermandad v1/v2 evita.
 */
import { camposCostosFijos, nombresCostosFijos } from "../ER/constants";

/**
 * Costos fijos del v2 = los 12 del v1 + Servicios Online.
 *
 * `servicios_online` es una `cuenta_er` que ya se venía clasificando (Google, Nubox y
 * similares) y que NO tenía línea destino en el ER: las facturas quedaban clasificadas,
 * fuera de toda línea y sumando en silencio al total sin clasificar, que además no se
 * renderiza. Costo real que se fugaba del EBITDA.
 *
 * Los dos arrays se indexan EN PARALELO (campo[i] ↔ nombre[i]) y varios consumidores del v2
 * dependen de esa alineación (`getCostoFijoValor` via indexOf, `costosFijosFilas`,
 * `costosFijosPorConcepto`). Agregar un concepto = agregarlo en AMBOS, al final.
 *
 * Pre-2026 la línea vale 0 por construcción: no hay campo homónimo en las tablas manuales,
 * así que `serieManualFija` no encuentra dato ni histórico para promediar y devuelve 0. La
 * paridad diff-cero contra el v1 en 2025 no se toca.
 */
export const camposCostosFijosV2 = [...camposCostosFijos, "servicios_online"];
export const nombresCostosFijosV2 = [...nombresCostosFijos, "Servicios Online"];
